export default function useHomeLinkMode() {
	const homeLink =
		process.env.ENVIRONMENT === 'PDN'
			? process.env.SITE_URL + '/'
			: process.env.ENVIRONMENT === 'STG'
			? process.env.SITE_STG + '/'
			: process.env.SITE_DEV + '/'
	return { homeLink }
}